<template>
	<div>
		<CCard class="p-4">
		<CRow>
			
			<CCol lg="6">
				<h5 style="font-weight: 600;"> Part Categories({{partCatList.total}})</h5>
			</CCol>

			<CCol lg="6">
				<CButton size="sm" style="float: right;" :class="'float-lg-right block '+showCollapse ? 'collapsed' : null"
			                 :aria-expanded="showCollapse ? 'true' : 'false'"
			                 aria-controls="collapse1"
			                 @click="showCollapse = !showCollapse"
			                 color="info"><i class="fa fa-search"></i>Filter<i :class="showCollapse ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i></CButton>
			        <CButton 
						v-if="config.getPermission('part_categories').create"
						size="sm" style="margin-right: 10px" 
						color="success" @click="toggleModal()" 
						class="float-lg-right"><i class="fa fa-plus"></i>Add Part Category
					</CButton>
		      		
		    </CCol>
		</CRow>
		<CRow> 
				<CCol lg="12">
					<CCollapse id="collapse1" :show="showCollapse" class="mt-2">
				        <CCard class="p-4">
				          <Search @partcat-search-query="search"/>
				        </CCard>
				      </CCollapse> 
				</CCol>
		</CRow> 
		<hr>
		<CRow>
			  
		      <CCol lg="12">  
				  <div class="table-responsive-sm table-responsive-md">
	      
			    	<CDataTable
					  :loading="isLoading"
				      :items="partCatList.data"
				      :fields="fields"
					  	   hover
         				  striped
						  outlined
						  
				    >  
				      	<template #action="{item}">
					        <td style="padding: 5px; width: 100px">
					        	<CDropdown 
					                toggler-text="Select"  
									size="sm"
					                color="info"
					            >
					               <CDropdownItem v-if="config.getPermission('part_categories').update" @click="updateModal(item)"><i class="fa fa-pencil-square-o"> Edit</i></CDropdownItem>
						            <CDropdownItem v-if="config.getPermission('part_categories').delete" @click="deleteRow(item)"><i class="fa fa-trash"> Delete</i></CDropdownItem> 
					            </CDropdown>
					        </td>
				      	</template>
				    </CDataTable> 
				    <CPagination
			          	:active-page.sync="currentPage"
			          	:pages="Math.ceil(partCatList.total / 20)"
			          	:activePage="currentPage"
			          	@update:activePage="updatePage"
			        />
			  
	      	</div>
	      </CCol>
	    </CRow>
	    <CModal :title="title" :show.sync="formModal" color="info">
           	<form @submit.prevent="submit">
           		<CRow>
					<CCol lg="12">
						<label>Part Category <span class="text-danger">*</span></label>
						<CInput
		                  
		                  placeholder="Enter part category"
		                  v-model="partCategoryName"
		                  required="true"
		                />
					</CCol>
				</CRow>
	            <div slot="footer" class="w-100">
	            	<CButton size="sm" style="border-radius: .2rem; color: white;" color="dark" class="ml-1 mr-1 float-right" @click="formModal = false">
	                    Cancel
	                </CButton>
	                <CButton size="sm" type="submit" style="border-radius: .2rem; color: white;" color="info" class="ml-1 mr-1 float-right">
	                   Save
	                </CButton>
	                
	            </div>
           	</form>
           	<div slot="footer" class="w-100"></div>
        </CModal>
		</CCard>
	</div>
</template>
<script>
import CTableWrapper from '../../base/Table.vue'
import usersData from '../../users/UsersData'
import config from '../../config.js';
import axios from '../../axios';
import Swal from 'sweetalert2';
import Search from './search'

export default {
	mounted(){
		console.log(config);
		this.getPartCategories();
	},
	data(){
		return{
			config,
			formModal: false,
			partCatList: [],
			partCategoryName: "",
			fields: [
				{
					key: 'setting_name', 
					label: 'Name'
				},
				{
					key: 'action',
					label: 'Action',
					_style: { width: '20px'}
				}
			],
			currentPage: 1,
			editMode: false,
			selectedRow: {},
			showCollapse: false,
			filterName: "",
			isLoading: false
		}
	},
	name: 'Tables',
	components: { CTableWrapper, Search },
	methods: {
		updatePage(data){
			this.currentPage = data;
			this.getPartCategories();
		},
	    shuffleArray (array) {
	      for (let i = array.length - 1; i > 0; i--) {
	        let j = Math.floor(Math.random() * (i + 1))
	        let temp = array[i]
	        array[i] = array[j]
	        array[j] = temp
	      }
	      return array
	    },

	    getShuffledUsersData () {
	      return this.shuffleArray(usersData.slice(0))
	    },

	    toggleModal(){
	    	this.formModal = !this.formModal;
			this.title = "Add Part Category";
	    },

	    submit(){
	    	var ax = {};
	    	if(this.editMode){
	    		ax = axios.put(config.api_path+"/setting/"+this.selectedRow.id, {
		    		setting_type: "part_category",
		    		setting_name: this.partCategoryName
		    	})
	    	}
	    	else{
	    		ax = axios.post(config.api_path+"/setting", {
		    		setting_type: "part_category",
		    		setting_name: this.partCategoryName
		    	})
	    	}
	    	ax.then(response => {
				const {status, message} = response.data;
				if(status == 'duplicate') {
					Swal.fire({
						title: message,
						text,
						icon: 'error', 
					})
					return;
				}
	    		var text = 'Part category successfully added!';
	    		if(this.editMode){
	    			text = 'Part category successfully updated!';
	    		}
	    		Swal.fire({
					title: 'Success!',
					text,
					icon: 'success', 
				})
	    		this.formModal = false
	    		this.editMode = false;
	    		this.partCategoryName = ""
	    		this.getPartCategories();
	    	})
	    },

	    search(event){
	    	this.filterName = event.name;
	    	this.getPartCategories();
	    },

	    getPartCategories(){

	    	this.isLoading=true;
	    	axios.get(config.api_path+'/setting?setting_type=part_category&setting_name='+this.filterName+'&page='+this.currentPage+'&limit=20')
	    	.then(response => {
	    		this.partCatList = response.data; 
	    	})
			.catch(err => {
				console.error(err)
				this.isLoading = false;
			})
			.finally(fin => {
				console.log(fin)
				this.isLoading = false;	
			})
	    },

	    updateModal(item){

			this.title = "Update Part Category";
	    	this.selectedRow = item;
	    	this.partCategoryName = item.setting_name;
	    	this.formModal = true;
	    	this.editMode = true;

	    },

	    deleteRow(item){
	    	Swal.fire({
				icon:'warning',
				title: 'Are you sure you want to delete this part category?', 
				showCancelButton: true,
				confirmButtonText: `Yes`, 
			}).then((result) => { 
				if (result.isConfirmed) {
					axios.delete(config.api_path+'/setting/'+item.id)
			    	.then(response => {
			    		this.getPartCategories(); 
			    		Swal.fire({
							title: 'Success!',
							text: "Part category successfully deleted",
							icon: 'success', 
						})
			    	}) 
				}
			})  
	    }

 	}
}
</script>
